{
  "LOGIN_FORM_HEADER_TITLE": "Cloud Cache Admin Login",
  "LOGIN_FORM_EMAIL_ADDRESS_TITLE": "User ID",
  "LOGIN_FORM_ACCESS_CODE_SENT_MESSAGE": "Access Code sent to your phone",
  "GET_ACCESS_CODE_BUTTON_TITLE": "Get Access Code",
  "LOGIN_FORM_ACCESS_CODE_TITLE": "Access Code",
  "LOGIN_FORM_PASSWORD_TITLE": "Password",
  "RESEND_CODE_BUTTON_TITLE": "Resend",
  "SIGN_IN_BUTTON_TITLE": "Sign In",
  "REQUIRED_VALIDATION_MESSAGE": "*Required",
  "INVALID_EMAIL_VALIDATION_MESSAGE": "Invalid Email Address",
  "INVALID_ACCESS_CODE_VALIDATION_MESSAGE": "Invalid Access Code",
  "REQUEST_METHOD_POST": "POST",
  "LOGIN_FORM_ACCESS_CODE_RESENT_MESSAGE": "Access Code resent to email address",
  "SERVER_DOWN_MESSAGE": "The Haven System is currently unreachable. Haven Administrator, please contact RBRO HAVEN Support Team.",
  "GENERIC_SERVER_DOWN_MESSAGE": "There was an error communicating with the server....",
  "PAGE_NOT_FOUND_HEADER": "Oops! Page not found",
  "PAGE_NOT_FOUND_MESSAGE": "we are sorry, but the page you requested was not found",
  "PAGE_NOT_FOUND_ERROR_CODE": "404",
  "INVALID_PASSWORD_VALIDATION_MESSAGE": "Invalid Password",
  "EDIT_ACTION_SUCCESS": "User Updated successfully",
  "ADD_ACTION_SUCCESS": "User Added in Haven Successfully",
  "DUPLICATE_USER": "Duplicate email Id",
  "CHNG_PWD_HEADER": "Enter new password for:",
  "GHNG_PWD_NEW_PASSWORD": "New Password",
  "GHNG_PWD_CONFIRM_PASSWORD": "Confirm New Password",
  "CHNG_PWD_BUTTON_TITLE": "Change Password",
  "PWD_RUL_MIN_8_CHRS": " Minimum 8 Characters",
  "PWD_RUL_ATLST_1_LCASE": "Atleast one Lowercase",
  "PWD_RUL_ATLST_1_UCASE": "Atleast one Uppercase",
  "PWD_RUL_ATLST_1_NUMBER": "Atleast one Number",
  "PWD_RUL_ATLST_1_SP_CHR": "Atleast one Special Character (!,@,#,$%,^,&,*)",
  "PWD_GOOD": "Good",
  "PWD_MATCH": "Match",
  "PWD_ST_REQ": "Password must match the requirements",
  "CNFM_PWD_REQ": "Confirm Password is required",
  "CNFM_PWD_NOT_MATCH": "Passwords must match",
  "CONFIRM_MSG": "There are unsaved changes. Do you want to continue?",
  "CONFIRM_YES": "Yes",
  "CONFIRM_NO": "No",
  "CONFIRM_TITLE": "Confirm",
  "ENABLE_CONNECTION": "Are you sure you want to enable \"{0}\" connection?",
  "DELETE_SUS_UPDTS": "Are you sure you want to delete the suspend update?",
  "DISABLE_CONNECTION": "Are you sure you want to disable \"{0}\" connection?",
  "ENABLE_CONNECTION_SUBMESG": "Cloud Cache will begin synchronizing libraries from configured iManage Work server.",
  "DISABLE_CONNECTION_SUBMESG": "Cloud Cache will stop synchronizing libraries from configured iManage Work server.",
  "PWD_SAVED_MESSAGE": "Password has been reset successfully",
  "SUSPEND_UPDATE_TYPE_DAILY": "Daily",
  "SUSPEND_UPDATE_TYPE_WEEKDAY": "WeekDay",
  "SUSPEND_UPDATE_TYPE_SPECIFIC_DATES": "Specific Dates",
  "FROM_TO_TIME_VALIDATION_MESSAGE": "*end time must always be after start time",
  "FROM_TO_DATE_VALIDATION_MESSAGE": "*end date time must always be after start date time",
  "INVALID_URL_MESSAGE": "Please provide the valid url",
  "CONFIRM_CONN_TITLE": "Confirm Connection Changes",
  "RMV_CONN_LBR_MSG": "Previously synced data will no longer be accessible after this change. Do you want to continue?",
  "CNF_DATA_CENTER_CHG_MSG": "Changing the data center will require HAVEN to sync all iManage data to a new library in the newly selected data center. The iManage password must be re-entered. Are you sure you like to perform this action?",
  "CNF_LIB_CHG_MSG": "Selecting a new iManage connection will require HAVEN to sync the libraries on that iManage server. Would you like to proceed?",
  "CNF_CONN_EDIT_RESET_MSG": "Saving changes will disable this connection and stop SPM synchronization. You will need to re-test and re-enable the connection afterwards.\n\nDo you want to continue?",
  "LIB_STORAGE_CHANGE_WARN_PREFIX": "If you are changing the storage for the ",
  "LIB_STORAGE_CHANGE_WARN_SUFFIX": " library, it will make previously cached content unavailable until a full synchronization is complete.",
  "EMAIL_REQUEST_SUCCESS": "Email Request Process Successfully",
  "FORGOT_PWD_LABEL":"Forgot Password?",
  "STOP_CONN_TST":"Are you sure you like to stop testing?",
  "IMANAGE":"iManage",
  "DATA_CENTER":"Data Center",
  "INACTIVE":"Inactive",
  "SAVE_CHANGES":"Save Changes",
  "RETAIN_DAYS":"Retain Days",
  "RETAIN_MSG":"Retain workspaces containing documents that have been edited/created within the last...",
  "TURN_ON_SCHEDULE":"Turn on schedule",
  "RUN_REPO_MSG":"Run Repository update every...",
  "HOME_CONNECTIONS":"Connections",
  "HOME_Status":"Status",
  "HOME_LAST":"Last Access Period",
  "HOME_CURRENT":"Current Access Period",
  "HOME_SYNC":"Synchronization Status",
  "HOME_LAST_SYNC":"Last Sync",
  "CONTENT_TXT":"Content:",
  "USERS_TXT":"Users:",
  "HOME_IMANAGE":"iManage Libraries",
  "HOME_DATA_CENTER":"Data Center",
  "CHANGES_SAVED":"Changes Saved",
  "USR_LGN_DNY_MSG":"Your account is blocked. Contact the system administrator.",
  "MSG_IN":" in ",
  "LOCK_USER_CONFIRM_MSG": "Are you sure you want to unlock the user"
}
